import 'reset-css';
import 'core-js/stable';
import Vue from 'vue';
import '@/utils/async-pkg-fallback';
import '@/public-path';
import '@/plugins/zoom-ui';
import '@/components/zoom-ui-plus/message/index';
import '@/plugins/common';
import '@/plugins/rewrireNumFix';
import ServiceComp from '@/plugins/service-comp';
import resolveI18n from '@/plugins/i18n';
import store from '@/store/index';
import routerCreator from '@/router/index';

import GlobalInstall from '@/global-install';
import { globalRebrandingMixin } from '@/global-install/global-mixin';
import GlobalListeners from '@/global-install/listeners';
import '@/utils/error-message-tracking.js';
import PortalVue from 'portal-vue';
Vue.use(PortalVue);

Vue.use(GlobalInstall);
Vue.use(ServiceComp);
Vue.mixin(globalRebrandingMixin);

import '@/styles/index.scss';

import View from "@/views/index";
import persistShoppingBag from '@/views/config/shopping-cart/persist/persist-cart';

Vue.config.productionTip = true;
Vue.config.devtools = true;

resolveI18n().then(i18n => {
  let options = {
    i18n,
    store,
    router: routerCreator(i18n),
    render: h => h(View),
    beforeCreate() {
      persistShoppingBag.initShoppingBagAction();
    },
    created(){
      (GlobalListeners.install.bind(this))();
    },
    beforeDestroy(){
      (GlobalListeners.uninstall.bind(this))();
    }
  };
  const App = new Vue(options);
  App.$mount('#app');
  window.__$app__ = Vue.__rootApp__ = App;
});


